import { databaseService } from "../firebase/firebase";

/**
 * Save a DCR entry under the current user's node.
 */
export const saveDCREntry = async (userId, entry) => {
  return databaseService.create(`DCR/${userId}`, entry);
};

/**
 * Fetch all DCR entries for a specific user.
 */
export const fetchDCREntries = async (userId) => {
  return databaseService.readAll(`DCR/${userId}`);
};

/**
 * Delete a DCR entry for a specific user.
 */
export const deleteDCREntry = async (userId, id) => {
  return databaseService.delete(`DCR/${userId}/${id}`);
};

/**
 * Fetch all DCR entries across all users (admin only).
 * Returns entries with an added `userId` field on each record.
 */
export const fetchAllDCREntriesAdmin = async () => {
  const snapshot = await databaseService.readAll("DCR");
  if (!snapshot || snapshot.length === 0) return [];

  const records = [];
  snapshot.forEach((userBucket) => {
    const userId = userBucket.id;
    Object.entries(userBucket).forEach(([entryId, entry]) => {
      if (entryId === "id") return;
      if (entry && typeof entry === "object") {
        records.push({ ...entry, userId });
      }
    });
  });

  return records.reverse();
};

/**
 * Delete any DCR entry by userId and entryId (admin only).
 */
export const deleteAnyDCREntry = async (userId, id) => {
  return databaseService.delete(`DCR/${userId}/${id}`);
};
